import { render, staticRenderFns } from "./VatNumber.vue?vue&type=template&id=4f0e30d9&scoped=true"
import script from "./VatNumber.vue?vue&type=script&lang=js"
export * from "./VatNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e30d9",
  null
  
)

export default component.exports